export const REGISTER_AN_ERROR = 'REGISTER_AN_ERROR'
export const SET_IS_ERROR_OVERLAY_VISIBLE = 'SET_IS_ERROR_OVERLAY_VISIBLE'
export const MAX_NUMBER_OF_REGISTERED_ERRORS = 120